import React from 'react';

const RequestInviteButton = () => {
  return (
    <button type="button" className="request-invite-button">
      Request Invite
    </button>
  );
};

export default RequestInviteButton;
